import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid auto-rows-max grid-cols-3 gap-x-2.5 gap-y-4 pb-4" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_skeleton = _resolveComponent("v-skeleton")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_skeleton, { class: "mb-3 h-5 w-full" }),
    _createVNode(_component_v_skeleton, { class: "mb-4 h-4 w-full" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_skeleton, {
        rep: 6,
        class: "aspect-starterset h-full w-full"
      })
    ]),
    _createVNode(_component_v_skeleton, { class: "btn mt-4 h-8 w-full" })
  ], 64))
}